// extracted by mini-css-extract-plugin
export default {"cls1":"k6F4TE_6WjDiUgzOevo2","cls2":"Z7zzoHMZhUrT_bgV73Dh k6F4TE_6WjDiUgzOevo2","hasheaderimage":"wan3rnPAXVvK8NjVRwqo","isTabletDown":"WlOKWGw76uPpjPDy7vcp"};